export const TITLE = {
    DELETE : 'Delete'
}

export const MESSAGE = {
    DELETE_MESSAGE : "Do you want to delete"
}

export const CONTENT_TYPE = {
    COURSE : "course",
    PATHWAY  : 'Pathway'
}

export const CONFIRM_TEXT = {
    DELETE : 'Delete'
}

export const CANCEL_TEXT = {
    CANCEL : "Cancel"
}

export const POPUP_TYPE = {
    WARNING: 'warning',
    ACTION : 'action'
}

export const WARNING = {
    COURSE_WARNING : "cannot be deleted, as it is either part of an active learning pathway, or it has been assigned to or completed by at least one learner.",
    PATHWAY_WARNING : "cannot be deleted, as it has been assigned to or completed by at least one learner."
}




 